import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";

const AvailOffer = ({ dataOffer, offer, setOffer, show }) => {
  const [modal, setModal] = useState({
    status: false,
    object: {},
  });
  useEffect(() => {
    if (!isEmpty(offer)) {
      setModal((prev) => {
        return {
          ...prev,
          object: dataOffer?.find((res) => {
            return res?._id == offer;
          }),
        };
      });
    }
  }, [offer, dataOffer]);
  return (
    <section className="deposit-discount-group">
      {show && (
        <div className="all-coupon-select-box">
          <ul id="bonusSelectBlockContainer" className="col-5">
            {dataOffer?.map((res) => {
              return (
                <li>
                  <input
                    // value={offer == res?._id}
                    checked={offer == res?._id}
                    type="radio"
                    name="bonusBlockSelect"
                  />
                  <div className="couponimg">
                    <div
                      className="bg-load pre-load data-image"
                      data-preload
                      style={{
                        backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL}${res?.offerImage})`,
                      }}
                    >
                      <label
                        onClick={() => {
                          setOffer(res?._id);
                          setModal({ status: false, object: res });
                        }}
                        className="status-check"
                      ></label>

                      <div
                        onClick={() =>
                          setModal({
                            status: true,
                            object: res,
                          })
                        }
                        className="status-more promotion-detail-btn"
                      ></div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {!isEmpty(modal?.object) && (
        <div id="selectedBonusTemplateContainer" className="coupon-group">
          <div
            className="coupon-banner bg-load pre-load data-image"
            style={{
              backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL}${modal?.object?.offerImage})`,
            }}
          />
          <div className="coupon-cont">
            <label>
              <ui-translate key="fe.text.deposit.promo" lang="en">
                Promotion
              </ui-translate>
            </label>
            <div className="coupon-tit">
              <strong>{modal?.object?.title}</strong>
            </div>
            <p>{modal?.object?.description}</p>
            <time>
              {" "}
              {moment(modal?.object?.offerStartDateTime).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}{" "}
              -{" "}
              {moment(modal?.object?.offerEndDateTime).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
            </time>
            <button
              onClick={() => {
                setModal({
                  ...modal,
                  status: true,
                });
              }}
              className="promotion-detail-btn"
              data-messagetype={3}
              data-id={133220}
              onclick="return false;"
            >
              <ui-translate key="fe.text.btn_show_detail" lang="en">
                Detail
              </ui-translate>
            </button>
          </div>
        </div>
      )}

      {modal?.status && (
        <Modal
          centered
          show={modal?.status}
          onHide={() =>
            setModal({
              ...modal,
              status: false,
            })
          }
          className="block-modal"
        >
          <Modal.Body style={{ padding: "0" }}>
            <div
              id="promotionPopupModal"
              className="pop-wrap promotion promotion-sty-a active Ani"
            >
              <div className="detail-banner">
                <img
                  style={{ width: "100%" }}
                  src={`${process.env.REACT_APP_API_BASE_URL}${modal?.object?.offerImage}`}
                />
                <div
                  onClick={() =>
                    setModal({
                      ...modal,
                      status: false,
                    })
                  }
                  className="btn-close dialog-close"
                  style={{ position: "absolute", top: "0", right: "0" }}
                />
              </div>
              <div
                className="pop-title mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                }}
              >
                <h3
                  className="messageTitle"
                  style={{ color: "#14805e" }}
                  ui-key="title"
                >
                  {modal?.object?.title}
                </h3>

                <span
                  onClick={() => {
                    setOffer(modal?.object?._id);
                    setModal({
                      status: false,
                      object: {},
                    });
                  }}
                  style={{
                    backgroundImage:
                      "linear-gradient(to right,#fbc103 0,#f79604 15%,#f79604 30%,#fbc103 55%,#fbc103 100%)",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "20px",
                    height: "2.1875rem",
                    fontSize: "14px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  Deposit now
                </span>
              </div>
              <div
                className="pop-inner"
                style={{ padding: "10px", paddingTop: "0" }}
              >
                <div className="article" ui-key="webContent">
                  <p>
                    <meta charSet="utf-8" />
                    <b
                      id="docs-internal-guid-e49a6a6d-7fff-26a3-cd6a-9b5b95c32c5b"
                      style={{ fontWeight: "normal" }}
                    >
                      <span
                        style={{
                          fontSize: "11pt",
                          fontFamily: "Arial,sans-serif",
                          color: "#000000",
                          backgroundColor: "transparent",
                          fontWeight: 400,
                          fontStyle: "normal",
                          fontVariant: "normal",
                          textDecoration: "none",
                          verticalAlign: "baseline",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {modal?.object?.description}
                      </span>
                      <br />
                    </b>
                    <p className="time" style={{ opacity: 1 }}>
                      {moment(modal?.object?.offerStartDateTime).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}{" "}
                      -{" "}
                      {moment(modal?.object?.offerEndDateTime).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </section>
  );
};

export default AvailOffer;
